/**
 * src/utils/formHelpers.js
 *
 * Pure utility functions for form validation and error formatting.
 * Previously located at src/actions/helper.js (moved to correct layer).
 *
 * Usage:
 *   import { checkValidations, checkError } from '../utils/formHelpers';
 */

/**
 * Validates all string fields in a state object, trimming whitespace.
 * Returns trimmed data and a comma-separated error string for empty required fields.
 *
 * @param {Object} state - The form state object to validate
 * @returns {{ data: Object, error: string|false }}
 */
export const checkValidations = (state) => {
  const newState = {};
  const noTrim = ['undefined', 'object', 'boolean', 'number'];
  let error = '';

  for (let [key, value] of Object.entries(state)) {
    if (!noTrim.includes(typeof value)) {
      value = value.trim();
      if (value === '' && key.charAt(0).toUpperCase() + key.slice(1) !== 'VatProviderEmail') {
        key = key.charAt(0).toUpperCase() + key.slice(1);
        error += `${key},`;
      }
      newState[key] = value;
    } else {
      newState[key] = value;
    }
  }

  if (error !== '') {
    error = error.substring(0, error.length - 1);
    error += ' is required!';
  } else {
    error = false;
  }

  return { data: newState, error };
};

/**
 * Formats a field-level errors object into an HTML unordered list string.
 * Returns an error HTML string and a `disabled` flag.
 *
 * @param {Object} errors - Map of field names to error message arrays
 * @returns {{ error: string, disabled: boolean }}
 */
export const checkError = (errors) => {
  let err = '<ul>';
  let disabled = false;

  for (const key of Object.keys(errors)) {
    if (errors[key].length > 0) {
      err += `<li>${key} ${errors[key]}<li>`;
      disabled = true;
    }
  }

  err += '</ul>';
  return { error: err, disabled };
};
